import { WorkflowResponseDto } from '@bandido/shared/dtos';

import { useGetAllTeams } from '@frontend/features/teams/queries';
import { useGetAllUsers } from '@frontend/features/users/queries';
import { useGetAllWorkflowsQuery, useGetStepsByManyWorkflowIds } from '@frontend/features/workflows/queries';
import { useGetAllClients } from '@frontend/features/clients/queries';

export const useFilterData = (agencyId: number, workflowIds: WorkflowResponseDto['id'][]) => {
  const { data: agentList } = useGetAllUsers({
    pageSize: 100,
    currentPage: 1,
    search: '',
    agencyId,
  });

  const { data: teamsList } = useGetAllTeams({
    pageSize: 100,
    currentPage: 1,
    agencyId: String(agencyId),
    search: '',
  });

  const { data: workflowsList } = useGetAllWorkflowsQuery({
    pageSize: 100,
    currentPage: 1,
    search: '',
    agencyId: String(agencyId),
  });

  const { data: clientsList } = useGetAllClients({
    pageSize: 100,
    currentPage: 1,
    agencyId,
  });

  const { data: stepsList } = useGetStepsByManyWorkflowIds({
    search: '',
    workflowIds,
  });

  return {
    agentList,
    teamsList,
    workflowsList,
    stepsList,
    clientsList,
  };
};
